export const PRO_INTRO = {
    eyebrow: "BUILDEASE PRO",
    copy: "BuildEase is developing a connected construction and property intelligence ecosystem designed to support better-informed decisions across the built environment. Whether you work in construction, property development, investment or project management, BuildEase aims to bring greater structure, visibility and intelligence to the decisions that shape projects and property assets.",
};

export const PRO_AUDIENCES = [
    {
        role: "Quantity Surveyors",
        value: "Structured cost and quantity information supporting professional workflows.",
    },
    {
        role: "Architects",
        value: "Improved visibility across architectural information and project coordination.",
    },
    {
        role: "Engineers",
        value: "Better-organised project documentation and construction information.",
    },
    {
        role: "Contractors",
        value: "Greater visibility into project information, quantities and cost considerations.",
    },
    {
        role: "Construction Project Managers",
        value: "Structured information supporting project oversight and decision-making.",
    },
    {
        role: "Property Developers",
        value: "Better visibility across development costs and project considerations.",
    },
    {
        role: "Property Investors",
        value: "Better-informed property development and investment decisions.",
    },
    {
        role: "Property Managers",
        value: "Improved visibility across property information and improvement decisions.",
    },
    {
        role: "Real-Estate Professionals",
        value: "Clearer construction and property information supporting client conversations.",
    },
];

export const PRO_ECOSYSTEM = {
    headline: "Your expertise. Connected to better construction intelligence",
    copy: "BuildEase aims to support professionals with tools and intelligence that complement their expertise, improve information visibility and help create more informed project decisions.",
    benefits: [
        {
            n: "01",
            title: "Workflow Intelligence",
            copy: "Structured construction information designed to fit professional workflows.",
        },
        {
            n: "02",
            title: "Cost Visibility",
            copy: "Clearer visibility of quantities, costs and the assumptions behind them.",
        },
        {
            n: "03",
            title: "Better-Informed Decisions",
            copy: "Evidence-based information supporting confident project decisions.",
        },
        {
            n: "04",
            title: "Professional Ecosystem",
            copy: "A developing network across construction, property and the built environment.",
        },
        {
            n: "05",
            title: "Future Opportunities",
            copy: "Early involvement in shaping the platform's professional capabilities.",
        },
    ],
    participation:
        "Be part of the intelligence shaping tomorrow's built environment",
};

export const PRO_ROLES = [
    "Quantity Surveyor",
    "Architect",
    "Engineer",
    "Contractor",
    "Construction Project Manager",
    "Property Developer",
    "Property Investor",
    "Property Manager",
    "Real-Estate Professional",
    "Other",
];

export const PRO_INDUSTRIES = [
    "Construction",
    "Property Development",
    "Real Estate",
    "Architecture & Design",
    "Engineering",
    "Financial Services & Investment",
    "Public Sector",
    "Other",
];

export const PRO_INTERESTS = [
    "BuildEase Pro access",
    "The professional network",
    "Partnership opportunities",
    "Platform updates",
    "Other",
];
